// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"d69b6fc6","488":"d789a13b","699":"be2193de","735":"448af6fa"}[chunkId] + ".chunk.js";
};